import * as React from 'react';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import BookmarkIcon from '@mui/icons-material/Bookmark';

function IndividualCardMassTreatmentPattern({ color, bigNumber, textOne, textTwo, textThree, larguraDaTela, atualizarTamanhoDaTela }) {

    React.useEffect(() => {
        // Adicionar um ouvinte de evento para o redimensionamento da janela
        window.addEventListener('resize', atualizarTamanhoDaTela);
        // Chamar a função inicialmente para pegar o tamanho da tela no início
        atualizarTamanhoDaTela();
        // Remover o ouvinte de evento quando o componente for desmontado
        return () => {
            window.removeEventListener('resize', atualizarTamanhoDaTela);
        };
    }, []);

    return (
        <React.Fragment>
            <CardContent style={larguraDaTela < 1800 ? styles.CardContentLargura : styles.CardContent}>
                <Box sx={[styles.BoxContent, { backgroundColor: color }]}>
                    <Box sx={styles.BoxContentIcon}>
                        <BookmarkIcon sx={styles.ContentIcon} />
                    </Box>
                    <Typography sx={styles.ContentBigNumber}>
                        {bigNumber}
                    </Typography>
                </Box>
                <Box sx={styles.BoxDescription}>
                    <Typography sx={styles.SecondFeaturedDescription}>
                        {textOne}
                    </Typography>
                    <Box sx={{ display: 'flex' }}>
                        <Typography sx={[styles.SecondFeaturedDescription, { marginRight: '4px' }]}>
                            com
                        </Typography>
                        <Typography sx={[styles.FeaturedDescription, { color: color }]}>
                            {textTwo}
                        </Typography>
                    </Box>
                    <Typography sx={[styles.FeaturedDescription, { color: color }]}>
                        {textThree}
                    </Typography>
                </Box>
            </CardContent>
        </React.Fragment >
    );
}

export default IndividualCardMassTreatmentPattern;

const styles = ({
    CardContent: {
        width: '20%',
        padding: '7px',
    },
    CardContentLargura: {
        width: '17%',
        padding: '7px',
    },
    BoxContent: {
        alignItems: 'center',
        borderRadius: '10px',
        height: '125px',
        display: 'flex',
        flexDirection: 'column'
    },
    BoxContentIcon: {
        alignSelf: 'end',
        display: 'flex',
        backgroundColor: '#ffffff70',
        width: '25px',
        height: '25px',
        borderRadius: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '8px 8px -7px 0px'
    },
    ContentIcon: {
        color: '#FFF',
        padding: '4px'
    },
    ContentBigNumber: {
        padding: '12px 15px 25px 15px',
        color: '#FFF',
        textAlign: 'center',
        fontSize: '41px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
    },
    BoxDescription: {
        // padding: '20px 0px 0px 10px'
        padding: '15px 0px 17px 10px'
    },
    FeaturedDescription: {
        fontSize: '13.5px',
        fontFamily: 'Montserrat',
        fontWeight: 'bold'
    },
    SecondFeaturedDescription: {
        fontSize: '13.5px',
        fontFamily: 'Montserrat'
    },
    CardActions: {
        // padding: '7px 0px 0px 0px'
        padding: '6px 8px 1px 6px'
    },
    Button: {
        textTransform: 'none'
    },
    BoxActionIcon: {
        display: 'flex',
        borderRadius: '100%'
    },
    IconButton: {
        fontSize: '16px',
        color: '#FFF'
    },
    ButtonText: {
        fontSize: '13px',
        fontWeight: '600',
        paddingLeft: '5px',
        fontFamily: 'Montserrat'
    }
});